export const GET_USERS = 'GET_USERS';

export const GET_DETAIL_EVENT_REQUESTED = 'GET_DETAIL_EVENT_REQUESTED';
export const GET_DETAIL_EVENT_SUCCESS = 'GET_DETAIL_EVENT_SUCCESS';
export const GET_DETAIL_EVENT_FAILED = 'GET_DETAIL_EVENT_FAILED';

export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const REGISTER_BEGIN = 'REGISTER_BEGIN';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const GET_EVENTS_BEGIN = 'GET_EVENTS_BEGIN';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAIL = 'GET_EVENTS_FAIL';

export const GET_EVENT_DETAIL_BEGIN = 'GET_EVENT_DETAIL_BEGIN';
export const GET_EVENT_DETAIL_SUCCESS = 'GET_EVENT_DETAIL_SUCCESS';
export const GET_EVENT_DETAIL_FAIL = 'GET_EVENT_DETAIL_FAIL';

export const GET_LIST_EVENT_BEGIN = 'GET_EVENT_DETAIL_BEGIN';
export const GET_LIST_EVENT_SUCCESS = 'GET_EVENT_DETAIL_SUCCESS';
export const GET_LIST_EVENT_FAIL = 'GET_EVENT_DETAIL_FAIL';

export const GET_EVENT_SEARCH_BEGIN = 'GET_EVENT_SEARCH_BEGIN';
export const GET_EVENT_SEARCH_SUCCESS = 'GET_EVENT_SEARCH_SUCCESS';
export const GET_EVENT_SEARCH_FAIL = 'GET_EVENT_SEARCH_FAIL';
